<template>
  <div
    ref="draggableContainer"
    class="position-fixed"
    :style="`z-index: 9999; cursor: pointer; opacity: .6; bottom: ${isMobileView ? '8%' : '5%'}; right: ${isMobileView ? '10px' : '30px'};`"
    :class="{ 'show': y > 250, 'd-none': y <= 250 }"
    @mousedown="dragMouseDown"
    @touchstart="dragTouchDown"
  >
    <!-- We have wrapper because ripple effect give position relative to this absolute positioned btn -->
    <!-- Hence due to that our btn get lost -->
    <b-button
      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
      variant="info"
      class="btn-icon"
      @click="scrollToTop"
    >
      <feather-icon
        icon="ArrowUpIcon"
        :size="isMobileView ? '16' : '28'"
      />
    </b-button>
  </div>
</template>

<script>
import { ref } from '@vue/composition-api'
import { useWindowScroll } from '@vueuse/core'
import { BButton } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'

export default {
  directives: {
    Ripple,
  },
  components: {
    BButton,
  },
  data() {
    return {
      positions: {
        clientX: undefined,
        clientY: undefined,
        movementX: 0,
        movementY: 0,
      },
    }
  },
  methods: {
    dragMouseDown(event) {
      event.preventDefault()
      // get the mouse cursor position at startup:
      this.positions.clientX = event.clientX
      this.positions.clientY = event.clientY
      document.onmousemove = this.elementDrag
      document.onmouseup = this.closeDragElement
    },
    elementDrag(event, preventDefault = true) {
      if (preventDefault) event.preventDefault()
      this.positions.movementX = this.positions.clientX - (event?.clientX || event?.changedTouches?.[0]?.clientX)
      this.positions.movementY = this.positions.clientY - (event?.clientY || event?.changedTouches?.[0]?.clientY)
      this.positions.clientX = event?.clientX || event?.changedTouches?.[0]?.clientX
      this.positions.clientY = event?.clientY || event?.changedTouches?.[0]?.clientY
      // set the element's new position:
      this.$refs.draggableContainer.style.top = `${this.$refs.draggableContainer.offsetTop - this.positions.movementY}px`
      this.$refs.draggableContainer.style.left = `${this.$refs.draggableContainer.offsetLeft - this.positions.movementX}px`
    },
    closeDragElement() {
      document.onmouseup = null
      document.onmousemove = null
      document.ontouchend = null
      document.ontouchmove = null
    },
    dragTouchDown(event) {
      // get the mouse cursor position at startup:
      this.positions.clientX = event.clientX
      this.positions.clientY = event.clientY
      document.ontouchmove = e => this.elementDrag(e, false)
      document.ontouchend = this.closeDragElement
    },
  },
  setup() {
    const { y } = useWindowScroll()

    const scrollToTop = () => {
      const rootEle = document.documentElement
      rootEle.scrollTo({
        top: 0,
        behavior: 'smooth',
      })
    }

    const draggableContainer = ref()

    return {
      y,
      scrollToTop,
      draggableContainer,
    }
  },

}
</script>

<style lang="scss" scoped>
.btn-scroll-to-top {
  position: fixed;
  bottom: 5%;
  right: 30px;
  z-index: 99;

  opacity: 0;
  // transform: translateY(100px);
  transition: all .5s ease;

    // width < md
  @media (max-width: 768px) {
    right: 10px;
    bottom: 8%;
  }

  &.show {
    opacity: 0.6;
    // transform: translateY(0)
    &:hover{
      opacity: 1;
    }
  }
}
</style>
